import { DateTime } from "luxon";

import { ajaxController } from "./controller/AjaxController";
import { clientMutationOptions } from "./controller/clientMutation";
import { PagedResult } from "../DTOs/Common/PagedResult";
import { FlatGroupOption } from "../DTOs/Common/FlatGroupOption";
import { PlantDTO } from "../DTOs/Plants/PlantDTO";
import { GcDrillingLineDTO, GcDrillingSessionDTO, SaveGcDrillingLineRequest } from "../DTOs/DrillBlast/GcDrillingDTO";
import { TripleShift } from "../types/Shift";

class GcDrillingAjax {
  private _ajaxController = ajaxController;
  private _endpoint = "/GcDrilling";

  public getAvailableRigs(shiftDate: DateTime, shift: TripleShift) {
    return this._ajaxController.get<PagedResult<PlantDTO>>(`${this._endpoint}/available-rigs/${shiftDate.toISODate()}/${shift[0]}`, {});
  }

  public getPitStages() {
    return this._ajaxController.get<PagedResult<FlatGroupOption>>(`${this._endpoint}/pit-stages`, {});
  }

  public getSession(shiftDate: DateTime, shift: TripleShift, rigId: number) {
    return this._ajaxController.get<GcDrillingSessionDTO | null>(`${this._endpoint}/drilling/${shiftDate.toISODate()}/${shift[0]}/${rigId}`, {});
  }

  public createSession(shiftDate: DateTime, shift: TripleShift, rigId: number, clientId?: string) {
    return this._ajaxController.post<object, GcDrillingSessionDTO>(
      `${this._endpoint}/drilling/${shiftDate.toISODate()}/${shift[0]}/${rigId}`, {}, undefined, undefined, clientMutationOptions(clientId));
  }

  public addLine(line: SaveGcDrillingLineRequest, clientId?: string) {
    return this._ajaxController.post<SaveGcDrillingLineRequest, GcDrillingLineDTO>(
      `${this._endpoint}/lines`, line, undefined, undefined, clientMutationOptions(clientId));
  }

  public updateLine(lineId: number, line: SaveGcDrillingLineRequest, clientId?: string) {
    return this._ajaxController.put<SaveGcDrillingLineRequest, GcDrillingLineDTO>(
      `${this._endpoint}/lines/${lineId}`, line, undefined, clientMutationOptions(clientId));
  }

  public deleteLine(lineId: number, clientId?: string) {
    return this._ajaxController.delete<boolean>(`${this._endpoint}/lines/${lineId}`, clientMutationOptions(clientId));
  }
}

export const gcDrillingAjax = new GcDrillingAjax();
